import React from 'react';
import Register from '@features/auth/components/register/Register';

const RegisterPage: React.FC = () => {
  return <Register />;
};

export default RegisterPage;